
const $ = require('jquery');
require('jquery-toast-plugin');

const ToastService = {
    error: (heading, message) => {
        $.toast({
            heading: heading,
            text: message,
            showHideTransition: 'slide',
            icon: 'error',
            position: 'top-right'
        });
    },
    success: (heading, message) => {
        $.toast({
            heading: heading,
            text: message,
            showHideTransition: 'slide',
            icon: 'success',
            position: 'top-right'
        });
    }
};

module.exports = ToastService;



// WEBPACK FOOTER //
// ./resources/assets/js/toast.js